export const calcTableHeight = ({
    headerHeight=29,
    rowHeight=56,
    rowsNumber=0
}) => {
    return headerHeight + rowHeight * rowsNumber;
}